import { getEnumValueLabel, TranslateLike } from './helper';

const COUPON_TYPE_KEY_MAP = {
  1: 'domain.coupon.type.store',
  2: 'domain.coupon.type.product',
} as const;

const COUPON_STATUS_KEY_MAP = {
  ALL: 'domain.coupon.status.all',
  ONGOING: 'domain.coupon.status.ongoing',
  SCHEDULED: 'domain.coupon.status.notStarted',
  ENDED: 'domain.coupon.status.expired',
  SUSPENDED: 'domain.coupon.status.suspended',
} as const;

export const getCouponTypeLabel = (t: TranslateLike, type?: 1 | 2) =>
  getEnumValueLabel(t, type, COUPON_TYPE_KEY_MAP);

export const getCouponStatusLabel = (
  t: TranslateLike,
  status?: 'ALL' | 'ONGOING' | 'SCHEDULED' | 'ENDED' | 'SUSPENDED',
) => getEnumValueLabel(t, status, COUPON_STATUS_KEY_MAP);
